/*
 * nc-pack-contents.js — keeps the curated-pack "what's in the box" list in sync with the
 * selected variant. Reads custom.component_list_json (embedded as data-pack-json), keyed by
 * variant title, and re-renders on Dawn's variantChange event so the 24-pack shows 2x each.
 */
(function () {
  'use strict';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function render(el, title) {
    var data;
    try {
      data = JSON.parse(el.dataset.packJson);
    } catch (e) {
      return;
    }
    var items = data[title];
    if (!items || !items.length) return;
    el.innerHTML = items
      .map(function (i) {
        return (
          '<li class="nc-pack-contents__item"><span class="nc-pack-contents__qty">' +
          i.quantity +
          '×</span> ' +
          esc(i.title) +
          '</li>'
        );
      })
      .join('');
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var el = document.querySelector('[data-nc-pack-contents]');
      var variant = event && event.data && event.data.variant;
      if (el && variant && variant.title) render(el, variant.title);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
